import dayjs from 'dayjs';
import { getDateFormat } from './getDateFormat';

export function apiaDateToStandarFormat(date: string) {
  const newDate = dayjs(date, getDateFormat());
  if (!newDate.isValid()) return '';
  return newDate.format('YYYY-MM-DD');
}
